/**
 * Merges a separate currency field into a price string.
 * Source of truth shared with scripts/migrate-apartment-upsell.js.
 */
export function mergeCurrencyIntoPrice(
  price: string | number | null | undefined,
  currency: string | null | undefined,
): { price: string | number | null; removeCurrency: boolean; merged: boolean } {
  if (!currency || typeof currency !== 'string' || !currency.trim()) {
    return { price: price ?? null, removeCurrency: false, merged: false };
  }

  const currencyStr = currency.trim();
  const priceStr = price == null ? '' : String(price).trim();

  if (!priceStr) {
    return { price: price ?? null, removeCurrency: true, merged: false };
  }

  if (priceStr.endsWith(currencyStr) || priceStr.includes(` ${currencyStr}`)) {
    return { price: priceStr, removeCurrency: true, merged: false };
  }

  return { price: `${priceStr} ${currencyStr}`, removeCurrency: true, merged: true };
}

/** Formats a price for display; appends currency when it is not already in the string. */
export function formatApartmentPrice(
  price: string | number | null | undefined,
  currency?: string | null,
): string {
  if (price === null || price === undefined || `${price}`.trim() === '') {
    return '';
  }

  const { price: mergedPrice } = mergeCurrencyIntoPrice(price, currency);
  if (mergedPrice === null || mergedPrice === undefined || `${mergedPrice}`.trim() === '') {
    return '';
  }

  return String(mergedPrice);
}
